module.exports = __webpack_public_path__ + "static/img/喻涛.2299754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/喻涛.jpg
// module id = /LyH
// module chunks = 138